import React, { Component } from 'react';
import { connect } from 'react-redux';
import './DetailsContractorsInvoices.css';
import {
  getCurrentWorkOrder,
  getTasks,
} from 'selectors/admin/work-orders/work-orders';
import AddInvoiceForm from 'components/admin/work-orders/details/contractors-invoices/AddInvoiceForm';
import { uploadContractorInvoiceRequest } from 'actions/admin/work-orders/details/details';
import {
  getContractorInvoice,
  getQuotes,
} from 'selectors/admin/work-orders/details/details';
import { getChangeOrderTasks } from 'components/admin/work-orders/details/change-order-tasks/store/selectors';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import DocumentLink from 'components/shared/document/DocumentLink';
import Number from 'components/shared/text/Number';

class DetailsContractorsInvoices extends Component {
  handleSubmit = (values) => {
    this.props.dispatch(
      uploadContractorInvoiceRequest(this.props.currentWorkOrder.id, values)
    );
  };

  render() {
    const { contractorInvoice, quotes, changeOrderTasks, tasks } = this.props;
    return (
      <div className="details-contractors-invoices">
        {contractorInvoice === null ? (
          <AddInvoiceForm
            quotes={quotes}
            changeOrderTasks={changeOrderTasks}
            tasks={tasks}
            onSubmit={this.handleSubmit}
          />
        ) : (
          <div className="invoice-form-readonly">
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  Amount
                </Col>
                <Col sm={9}>
                  <Number value={contractorInvoice.cost} format="$0,0" />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  Document
                </Col>
                <Col sm={9}>
                  <DocumentLink
                    showIcon={false}
                    url={contractorInvoice.document.document.url}
                  />
                </Col>
              </FormGroup>
            </Form>
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => {
  return {
    contractorInvoice: getContractorInvoice(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    quotes: getQuotes(state),
    changeOrderTasks: getChangeOrderTasks(state),
    tasks: getTasks(state),
  };
})(DetailsContractorsInvoices);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/contractors-invoices/DetailsContractorsInvoices.js